import { render, staticRenderFns } from "./ClientProfileTabComponent.vue?vue&type=template&id=72fe9b4e&scoped=true&"
import script from "./ClientProfileTabComponent.vue?vue&type=script&lang=ts&"
export * from "./ClientProfileTabComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ClientProfileTabComponent.vue?vue&type=style&index=0&id=72fe9b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fe9b4e",
  null
  
)

export default component.exports